
import { Component, Vue } from "vue-property-decorator";
import { Route } from "vue-router";
import { setSawVideoTutorial } from "../../utils/VideoTutorialUtil";

@Component
export default class UserManual extends Vue {
  beforeRouteLeave(to: Route, from: Route, next: CallableFunction) {
    setSawVideoTutorial(true);
    next();
  }
}
